import React from "react"
import styles from "./wide-pattern.module.scss"
import cx from "classnames"

const WidePattern = ({ type }) => {
  return <div className={cx(styles.Pattern, styles[type])}></div>
}
export default WidePattern
